import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  isco: []
}

// getters
export const getters = {
  isco: state => state.isco,
}

// mutations
export const mutations = {
  [types.FETCH_ISCO_SUCCESS] (state, { isco }) {
    state.isco = isco;
  },

  [types.FETCH_ISCO_FAILURE] (state) {
    state.isco = [];
  },
}

// actions
export const actions = {
  async fetchISCO ({ commit }) {
    try {
      const response = await axios.get(`/api/isco`);

      commit(types.FETCH_ISCO_SUCCESS, { isco: response.data })
    } catch (error) {
      console.error(error);
      commit(types.FETCH_ISCO_FAILURE)
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/isco.js